import {
  ADD_PERMISSION,
  ADD_ROLE,
  DELETE_ACTION,
  DELETE_PERMISSION,
  DELETE_ROLE,
  GET_ACTION,
  GET_ACTION_SUCCEED,
  GET_PERMISSION,
  GET_ROLE_INFO_BY_ID,
  GET_PERMISSION_FAIL,
  GET_PERMISSION_SUCCEED,
  GET_ROLES,
  GET_ROLES_SUCCEED,
  POST_ACTION,
  POST_PERMISSION_CONTROL_FOR_ROLE,
  PUT_PERMISSION,
} from './action_types';

export default {
  addPermission: (data) => ({
    type: ADD_PERMISSION,
    params: {
      data,
    },
  }),
  getPermission: (pos, count, callback = () => void (0)) => ({
    type: GET_PERMISSION,
    params: {
      pos,
      count,
    },
    callback,
  }),
  getPermissionSucceed: (permissions, totalCount) => ({
    type: GET_PERMISSION_SUCCEED,
    params: {
      permissions,
      totalCount,
    },
  }),
  getPermissionFail: () => ({
    type: GET_PERMISSION_FAIL,
  }),

  putPermission: (params, callback) => ({
    type: PUT_PERMISSION,
    params,
    callback,
  }),

  postRole: (data, callback) => ({
    type: ADD_ROLE,
    params: data,
    callback,
  }),

  getRoles: (callback = () => void (0)) => ({
    type: GET_ROLES,
    callback,
  }),

  getRolesSucceed: (roles, totalCount) => ({
    type: GET_ROLES_SUCCEED,
    params: {
      roles,
      totalCount,
    },
  }),

  postAction: (action, name, description) => ({
    type: POST_ACTION,
    params: {
      action,
      name,
      description,
    },
  }),

  getAction: (callback) => ({
    type: GET_ACTION,
    callback,
  }),

  getActionSucceed: (actions, totalCount) => ({
    type: GET_ACTION_SUCCEED,
    params: {
      actions,
      totalCount,
    },
  }),

  deleteAction: (controlId) => ({
    type: DELETE_ACTION,
    params: {
      controlId,
    },
  }),

  getRoleInfoById: (roleId, callback) => ({
    type: GET_ROLE_INFO_BY_ID,
    params: {
      roleId,
    },
    callback,
  }),
  postPermissionsControlsForRole: (data, callback) => ({
    type: POST_PERMISSION_CONTROL_FOR_ROLE,
    params: data,
    callback,
  }),
  deletePermission: (permissionId) => ({
    type: DELETE_PERMISSION,
    params: {
      permissionId,
    },
  }),
  deleteRole: (roleId) => ({
    type: DELETE_ROLE,
    params: {
      roleId,
    },
  }),
};
